'use client';

import React, { useRef, useState, useEffect } from 'react';
import { testimony } from '@/constants';

export const TestimonyCarousel = () => {
    const [scrollAmount, setScrollAmount] = useState(320);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setScrollAmount(320);
            } else {
                setScrollAmount(840);
            }
            updateScrollButtons();
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const updateScrollButtons = () => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
        }
    };

    const scroll = (direction: 'left' | 'right') => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        updateScrollButtons();
        el.addEventListener('scroll', updateScrollButtons);
        window.addEventListener('resize', updateScrollButtons);

        return () => {
            el.removeEventListener('scroll', updateScrollButtons);
            window.removeEventListener('resize', updateScrollButtons);
        };
    }, []);

    return (
        <div className="relative px-8 md:px-12">
            <div ref={scrollRef} className="overflow-x-auto scrollbar-hide">
                <div className="flex gap-6 py-4 w-max">
                    {testimony.map((item, index) => (
                        <div
                            key={index}
                            className="flex flex-col md:flex-row bg-main-100 rounded-xl shadow-[4px_4px_6px_0px_#0000000F] min-w-[260px] md:min-w-[700px] max-w-[80vw] md:max-w-[900px] h-auto md:h-[280px] overflow-hidden"
                        >
                            <div className="w-full md:w-[30%] h-[200px] md:h-full shrink-0">
                                <img
                                    src={item.imageSrc}
                                    alt={item.name}
                                    className="w-full h-full object-cover"
                                />
                            </div>

                            <div className="w-full md:w-[70%] p-4 md:p-6 flex flex-col overflow-hidden">
                                <h2 className="text-lg md:text-2xl text-secondary-100 font-bold mb-1">
                                    {item.name}
                                </h2>
                                <h5 className="text-sm md:text-base text-accent-100 font-medium mb-3">
                                    Alumni batch {item.batch}
                                </h5>
                                <p className="text-xs md:text-sm text-secondary-100 text-justify leading-relaxed">
                                    {item.tetimony}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {canScrollLeft && (
                <button
                    onClick={() => scroll('left')}
                    className="ml-12 absolute left-2 top-1/3 md:top-1/2 transform -translate-y-1/2 bg-[rgb(13,148,136)] text-black rounded-full shadow-md z-10 hover:bg-gray-200 w-8 h-8 flex items-center justify-center"
                >
                    <img src="/img/home/left-arrow.png" alt="Kiri" />
                </button>
            )}
            {canScrollRight && (
                <button
                    onClick={() => scroll('right')}
                    className="mr-12 absolute right-2 top-1/3 md:top-1/2 transform -translate-y-1/2 bg-[rgb(13,148,136)] text-black rounded-full shadow-md z-10 hover:bg-gray-200 w-8 h-8 flex items-center justify-center"
                >
                    <img src="/img/home/right-arrow.png" alt="Kanan" />
                </button>
            )}
        </div>
    );
};
